/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabaseNewsletterAusfuehrung } from './DatabaseNewsletterAusfuehrung';
import {
    DatabaseNewsletterAusfuehrungFromJSON,
    DatabaseNewsletterAusfuehrungFromJSONTyped,
    DatabaseNewsletterAusfuehrungToJSON,
} from './DatabaseNewsletterAusfuehrung';
import type { DatabaseNewsletterFeld } from './DatabaseNewsletterFeld';
import {
    DatabaseNewsletterFeldFromJSON,
    DatabaseNewsletterFeldFromJSONTyped,
    DatabaseNewsletterFeldToJSON,
} from './DatabaseNewsletterFeld';
import type { DatabaseNewsletterHoehe } from './DatabaseNewsletterHoehe';
import {
    DatabaseNewsletterHoeheFromJSON,
    DatabaseNewsletterHoeheFromJSONTyped,
    DatabaseNewsletterHoeheToJSON,
} from './DatabaseNewsletterHoehe';
import type { DatabaseNewsletterMuster } from './DatabaseNewsletterMuster';
import {
    DatabaseNewsletterMusterFromJSON,
    DatabaseNewsletterMusterFromJSONTyped,
    DatabaseNewsletterMusterToJSON,
} from './DatabaseNewsletterMuster';
import type { DatabasePageBlock } from './DatabasePageBlock';
import {
    DatabasePageBlockFromJSON,
    DatabasePageBlockFromJSONTyped,
    DatabasePageBlockToJSON,
} from './DatabasePageBlock';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseNewsletterPageBlock
 */
export interface DatabaseNewsletterPageBlock extends DatabasePageBlock {
    /**
     * Ueberschrift und Fliesstext des Bandes, als HTML aus dem
     * gewoehnlichen Editor.
     * 
     * WARUM HIER UND NICHT IM GRUNDBAUSTEIN: `content` steht nur am
     * TEXT-Baustein. Ein Wert, den das Schema nicht kennt, wird beim
     * Speichern STILL verworfen — gemessen am 17.09.2026 auf DEV: Das
     * Band stand ohne Ueberschrift da, und nichts meldete einen Fehler.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    fontFamily?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseNewsletterPageBlock
     */
    fontSize?: DatabaseFontSizeEnum;
    /**
     * Die Zieldatenbank — dort entsteht je Anmeldung ein Datensatz.
     * Ueblicherweise eine Unterdatenbank („Newsletter-Anmeldungen").
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    childDatabaseId?: string;
    /**
     * 
     * @type {DatabaseNewsletterHoehe}
     * @memberof DatabaseNewsletterPageBlock
     */
    hoehe?: DatabaseNewsletterHoehe;
    /**
     * 
     * @type {DatabaseNewsletterAusfuehrung}
     * @memberof DatabaseNewsletterPageBlock
     */
    ausfuehrung?: DatabaseNewsletterAusfuehrung;
    /**
     * 
     * @type {DatabaseNewsletterMuster}
     * @memberof DatabaseNewsletterPageBlock
     */
    muster?: DatabaseNewsletterMuster;
    /**
     * Die kleine Pille ueber der Ueberschrift, etwa „NEWSLETTER-VORTEIL".
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    pillenText?: string;
    /**
     * Die Beschriftung des Knopfes im Band.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    knopfText?: string;
    /**
     * NICHT MEHR IN GEBRAUCH seit 24.09.2026. Das Kleingedruckte stand
     * neben dem Knopf („1× monatlich • 0 % Spam"); im Entwurf des
     * Betreibers gibt es es nicht mehr — er hat das Feld in der Maske
     * durchgestrichen: „Das Feld gibt es nicht?"
     * 
     * Das Feld bleibt im Schema, damit bestehende Baender nicht beim
     * Speichern stolpern. Gemessen am 24.09.2026 ueber alle 216
     * Datenbanken und Vorlagen: acht Newsletter-Baender, KEINES mit
     * Kleingedrucktem — es ging also kein Text verloren.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    metaText?: string;
    /**
     * ZWEITE FARBE DES BANDES („Verlauf bis"). Die erste ist die
     * Grundfarbe des Bausteins (`backgroundColor`) — Betreiber
     * 24.09.2026: „Hintergrund ist doch der Verlauf." Zusammen ergeben
     * sie den Verlauf; ohne die zweite ist das Band einfarbig.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    verlaufFarbe?: string;
    /**
     * Grund des Knopfes im Band. Ohne Angabe weiss.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    knopfFarbe?: string;
    /**
     * Schrift auf dem Knopf. Vierter Farbwaehler der Vorgabe vom
     * 24.09.2026 („Button Text"). Ohne Angabe richtet sie sich nach dem
     * Grund des Knopfes: auf hellem Grund dunkel, auf dunklem hell.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    knopfSchriftFarbe?: string;
    /**
     * Grund der Pille („Badge") im Band. Ohne Angabe liegt sie als
     * heller Schleier auf dem Verlauf, so wie bisher.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    badgeFarbe?: string;
    /**
     * Schrift in der Pille. Ohne Angabe die Schriftfarbe des Bandes.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    badgeSchriftFarbe?: string;
    /**
     * Rahmen des BANDES in Pixeln (0 = ohne). Nicht zu verwechseln mit
     * der Rahmenbreite im Reiter „Position" — die gehoert der Flaeche
     * des Bausteins.
     * @type {number}
     * @memberof DatabaseNewsletterPageBlock
     */
    rahmenBreite?: number;
    /**
     * Farbe des Rahmens um das Band.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    rahmenFarbe?: string;
    /**
     * Grund des Absende-Knopfes im Formular. Ohne Angabe die erste
     * Farbe des Bandes — so gehoeren Band und Formular sichtbar
     * zusammen.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    popupKnopfFarbe?: string;
    /**
     * Schrift auf dem Absende-Knopf. Ohne Angabe weiss.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    popupKnopfSchriftFarbe?: string;
    /**
     * Schriftfarbe im Band. Ohne Angabe weiss.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    fontColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    popupTitel?: string;
    /**
     * Der Hinweistext unter der Ueberschrift des Popups. SEIT
     * 24.09.2026 HTML aus dem gewoehnlichen Editor („Bitte bei
     * Hinweis-Text auch ein TipTap Editor hinzufuegen") — vorher
     * Klartext. Alter Klartext wird weiterhin richtig angezeigt.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    popupText?: string;
    /**
     * Die Beschriftung des Absende-Knopfes.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    popupKnopfText?: string;
    /**
     * Die Geschenk-Pille im Popup („🎁 Gutschein für 1 Gratis-Runde").
     * LEER heisst: keine Pille — das ist die Sicht „ohne Goody" aus dem
     * Prototyp des Betreibers.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    goodyText?: string;
    /**
     * Die Felder des Formulars, in ihrer Reihenfolge.
     * @type {Array<DatabaseNewsletterFeld>}
     * @memberof DatabaseNewsletterPageBlock
     */
    eingabeFelder?: Array<DatabaseNewsletterFeld>;
    /**
     * Das Ja/Nein-Feld der Zieldatenbank, in dem die Zustimmung landet.
     * Ohne Angabe wird kein Haekchen gezeigt.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    zustimmungFeldId?: string;
    /**
     * Der Text neben dem Haekchen, als HTML aus dem gewoehnlichen
     * Editor. Betreiber 17.09.2026: „Der Link auf die AGB oder
     * Datenschutz muss auf interne Dokumente möglich sein
     * (TipTap-Editor)." Deshalb HTML und nicht Klartext — die
     * `db:`-Befehle (Impressum, Nutzungsbedingungen, Datenschutz,
     * Bibliotheksdatei) werden beim Antippen aufgeloest.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    zustimmungText?: string;
    /**
     * Ohne Haekchen laesst sich nicht absenden.
     * @type {boolean}
     * @memberof DatabaseNewsletterPageBlock
     */
    zustimmungPflicht?: boolean;
    /**
     * Die Meldung, die nach dem Absenden erscheint.
     * @type {string}
     * @memberof DatabaseNewsletterPageBlock
     */
    erfolgsText?: string;
    /**
     * Nach erfolgreicher Anmeldung verschwindet das Band fuer diesen
     * Datensatz — sonst steht es weiter da, als waere nichts geschehen.
     * @type {boolean}
     * @memberof DatabaseNewsletterPageBlock
     */
    nachSendenVerbergen?: boolean;
}

/**
 * Check if a given object implements the DatabaseNewsletterPageBlock interface.
 */
export function instanceOfDatabaseNewsletterPageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseNewsletterPageBlockFromJSON(json: any): DatabaseNewsletterPageBlock {
    return DatabaseNewsletterPageBlockFromJSONTyped(json, false);
}

export function DatabaseNewsletterPageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseNewsletterPageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabasePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'content': !exists(json, 'content') ? undefined : json['content'],
        'fontFamily': !exists(json, 'fontFamily') ? undefined : json['fontFamily'],
        'fontSize': !exists(json, 'fontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['fontSize']),
        'childDatabaseId': !exists(json, 'childDatabaseId') ? undefined : json['childDatabaseId'],
        'hoehe': !exists(json, 'hoehe') ? undefined : DatabaseNewsletterHoeheFromJSON(json['hoehe']),
        'ausfuehrung': !exists(json, 'ausfuehrung') ? undefined : DatabaseNewsletterAusfuehrungFromJSON(json['ausfuehrung']),
        'muster': !exists(json, 'muster') ? undefined : DatabaseNewsletterMusterFromJSON(json['muster']),
        'pillenText': !exists(json, 'pillenText') ? undefined : json['pillenText'],
        'knopfText': !exists(json, 'knopfText') ? undefined : json['knopfText'],
        'metaText': !exists(json, 'metaText') ? undefined : json['metaText'],
        'verlaufFarbe': !exists(json, 'verlaufFarbe') ? undefined : json['verlaufFarbe'],
        'knopfFarbe': !exists(json, 'knopfFarbe') ? undefined : json['knopfFarbe'],
        'knopfSchriftFarbe': !exists(json, 'knopfSchriftFarbe') ? undefined : json['knopfSchriftFarbe'],
        'badgeFarbe': !exists(json, 'badgeFarbe') ? undefined : json['badgeFarbe'],
        'badgeSchriftFarbe': !exists(json, 'badgeSchriftFarbe') ? undefined : json['badgeSchriftFarbe'],
        'rahmenBreite': !exists(json, 'rahmenBreite') ? undefined : json['rahmenBreite'],
        'rahmenFarbe': !exists(json, 'rahmenFarbe') ? undefined : json['rahmenFarbe'],
        'popupKnopfFarbe': !exists(json, 'popupKnopfFarbe') ? undefined : json['popupKnopfFarbe'],
        'popupKnopfSchriftFarbe': !exists(json, 'popupKnopfSchriftFarbe') ? undefined : json['popupKnopfSchriftFarbe'],
        'fontColor': !exists(json, 'fontColor') ? undefined : json['fontColor'],
        'popupTitel': !exists(json, 'popupTitel') ? undefined : json['popupTitel'],
        'popupText': !exists(json, 'popupText') ? undefined : json['popupText'],
        'popupKnopfText': !exists(json, 'popupKnopfText') ? undefined : json['popupKnopfText'],
        'goodyText': !exists(json, 'goodyText') ? undefined : json['goodyText'],
        'eingabeFelder': !exists(json, 'eingabeFelder') ? undefined : ((json['eingabeFelder'] as Array<any>).map(DatabaseNewsletterFeldFromJSON)),
        'zustimmungFeldId': !exists(json, 'zustimmungFeldId') ? undefined : json['zustimmungFeldId'],
        'zustimmungText': !exists(json, 'zustimmungText') ? undefined : json['zustimmungText'],
        'zustimmungPflicht': !exists(json, 'zustimmungPflicht') ? undefined : json['zustimmungPflicht'],
        'erfolgsText': !exists(json, 'erfolgsText') ? undefined : json['erfolgsText'],
        'nachSendenVerbergen': !exists(json, 'nachSendenVerbergen') ? undefined : json['nachSendenVerbergen'],
    };
}

export function DatabaseNewsletterPageBlockToJSON(value?: DatabaseNewsletterPageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabasePageBlockToJSON(value),
        'content': value.content,
        'fontFamily': value.fontFamily,
        'fontSize': DatabaseFontSizeEnumToJSON(value.fontSize),
        'childDatabaseId': value.childDatabaseId,
        'hoehe': DatabaseNewsletterHoeheToJSON(value.hoehe),
        'ausfuehrung': DatabaseNewsletterAusfuehrungToJSON(value.ausfuehrung),
        'muster': DatabaseNewsletterMusterToJSON(value.muster),
        'pillenText': value.pillenText,
        'knopfText': value.knopfText,
        'metaText': value.metaText,
        'verlaufFarbe': value.verlaufFarbe,
        'knopfFarbe': value.knopfFarbe,
        'knopfSchriftFarbe': value.knopfSchriftFarbe,
        'badgeFarbe': value.badgeFarbe,
        'badgeSchriftFarbe': value.badgeSchriftFarbe,
        'rahmenBreite': value.rahmenBreite,
        'rahmenFarbe': value.rahmenFarbe,
        'popupKnopfFarbe': value.popupKnopfFarbe,
        'popupKnopfSchriftFarbe': value.popupKnopfSchriftFarbe,
        'fontColor': value.fontColor,
        'popupTitel': value.popupTitel,
        'popupText': value.popupText,
        'popupKnopfText': value.popupKnopfText,
        'goodyText': value.goodyText,
        'eingabeFelder': value.eingabeFelder === undefined ? undefined : ((value.eingabeFelder as Array<any>).map(DatabaseNewsletterFeldToJSON)),
        'zustimmungFeldId': value.zustimmungFeldId,
        'zustimmungText': value.zustimmungText,
        'zustimmungPflicht': value.zustimmungPflicht,
        'erfolgsText': value.erfolgsText,
        'nachSendenVerbergen': value.nachSendenVerbergen,
    };
}

